import { render, staticRenderFns } from "./PaymentFormPage.vue?vue&type=template&id=771aa186&scoped=true"
import script from "./PaymentFormPage.vue?vue&type=script&lang=js"
export * from "./PaymentFormPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentFormPage.vue?vue&type=style&index=0&id=771aa186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771aa186",
  null
  
)

export default component.exports